
import * as ChatStrategy from "./firebase.service.helper"
import { getCommunityId } from "../store/communities.store";
import {getUserData} from  "../store/user.store"
import { axiosAuthInstance } from "../config/axios-config";

// import { axiosAuthInstance } from "../config/axios-config";
// import { getCommunityId } from "../store/communities.store";
import { Subject } from "rxjs";


// import debounceTime from "rxjs/operators/debounceTime"


// const myObservable = new rxjs.Observable((subscriber) => {
//     subscriber.next(1)})
//     .pipe(
//         debaounceTime(1000),
//     )

// const sub = new rxjs.Subject()

// const createSubjectWithObjservable = (observer) => {
//     const sub = new rxjs.Subject()

//     sub.subscribe(observer)

//     return sub.next
// }
// let globalWebToken = null;

async function getFirebaseWebToken(){

    // if(globalWebToken && globalWebToken.expireAt < Date.now()){
    //     return globalWebToken.token
    // }
    // else{
    return axiosAuthInstance.get("/social/firebase-auth-token")
    .then((res)=>{
        return res.data
    })
    // }

}


// console.log("LOGING ENV VAR", process.env)
const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || "{}")
const communityId = getCommunityId()
const userObjectGet  = getUserData()
let userObject = null
// let chatStrat = null //Set later
// const userObject  = {
//     "imageUrl": "",
//     "gender": "Male",
//     "socialId": "DreIntl",
//     "isBuddy": null,
//     "userId": "018b423e-803c-7000-a4c2-0a8510a76397",
//     "name": "Dre Intl",
//     "email": "",
//     "statusMessage": ""
//   }
// const chatStrat = new ChatStrategy.ChatServiceInitialStrategy("018b423e-803c-7000-a4c2-0a8510a76397")



function initChatService(){
    let userkk = null
    // if(fu_res.error){
    userkk= {
        "imageUrl": userObjectGet.portraitImageUrl??userObjectGet.imageUrl??null,
        "gender" : userObjectGet.gender,
        "socialId": userObjectGet.socialId??userObjectGet.id,
        "isBuddy": null,
        "userId": userObjectGet.id,
        "name": userObjectGet.fullName,
        "email": userObjectGet.email,
        "statusMessage": userObjectGet.statusMessage??""
    }

    return userkk;
}

let chatStrat= null;

// console.log(chatStrat, "Current User Id :-> ", getUserData())
var ChatService = {
    a: "sdf",
    inited: false,
    initingPromise: null,
    chatboxOpen: false,
    isAllMsgReadCollection: new Map(),
    _openChatViewSubject : new Subject(),
    _notificationStateSubject : new Subject(),
    _onChatBoxOpenStateChange : new Subject(),
    _virutalContactList : new Map(),
    initialize: async function (){
        let chatServiceThis = this
        let customPromise = new Promise(
            async (resolve, reject)=>{
                if(!chatServiceThis.inited){
                    let result1 = await getFirebaseWebToken().then(
                        (theToken) => {
                            userObject = initChatService();
                            chatStrat = new ChatStrategy.ChatServiceInitialStrategy(
                                userObject
                                ,firebaseConfig
                                ,theToken.token
                                ,communityId 
                                ,""
                            );
                            // console.log(chatStrat);
                        },
                        (reason) => {
                            // console.log("WebToken Error: ", reason)
                        }
                    )
                    
                    resolve(result1)
                    
                    
                }else{
                    chatStrat ? resolve(chatStrat) : resolve(chatServiceThis.initingPromise)
                }
            }
        )
        chatServiceThis.initingPromise = customPromise
        chatServiceThis.inited = true

        return customPromise;

    },
    setChatBoxOpenState: function (val){
        this.chatboxOpen = val;
        
        this._onChatBoxOpenStateChange.next(val);
    },
    getChatBoxOpenState: function (){
        return this.chatboxOpen;
    },
    getCurrentUserId:()=>{return chatStrat?.userId},
    setIsMsgReadStatus: function( msgKey, isAllMsgRead){
        // msgKey is just the msg tab "direct" | "role-specific" | "mail/incidents"
        this.isAllMsgReadCollection.set(msgKey, isAllMsgRead);
        this.updateMessageNotificationState();
    },
    updateMessageNotificationState: function(){
        // console.log("falser Map Object State : ", this.isAllMsgReadCollection)
        let notistate = Array.from(this.isAllMsgReadCollection.values()).every((val,ind,arr)=>{
            return val
        });
        this._notificationStateSubject.next(notistate);
    },
    
    subscribeToRecipientConversationListData( newDataCallback, errorCallback, conversationFilterOption){
        //conversationType = "mail/incidents" | "role-specific" | "direct"

        // chatStrat.subscribeToConversationEventHandler(
        //     newDataCallback,
        //     errorCallback
        // )


        return chatStrat.subscribeToConversationRecipentEventHandlerWithPredicate(
            newDataCallback,
            errorCallback,
            ( data, index, arr )=>{
                switch (conversationFilterOption){
                    case "mail/incidents":
                        return ((data.conversationType)??"") === "mail" || data.conversationType === "incident";
                    case "role-specific":
                        // return Boolean(data.recipientRoles) && data.communityId === communityId
                        return ((data.conversationType)??"") === "roleSpecific" && data.communityId === communityId
                    case "direct":
                        // return data.isIncident !== true && !data.recipientRoles
                        return ((data.conversationType)??"") === "direct"
                    default:
                        return false;
                }
                    
            }
        )
    },
    subscribeToGroupConversationListData( newDataCallback, errorCallback, conversationFilterOption){
        //conversationType = "mail/incidents" | "role-specific" | "direct"

        // chatStrat.subscribeToConversationEventHandler(
        //     newDataCallback,
        //     errorCallback
        // )

        return chatStrat.subscribeToConversationGroupEventHandlerWithPredicate(
            newDataCallback,
            errorCallback,
            ( data, index, arr )=>{
                switch (conversationFilterOption){
                    case "mail/incidents":
                        return ((data.conversationType)??"") === "mail" || data.conversationType === "incident";
                    case "role-specific":
                        // return Boolean(data.recipientRoles) && data.communityId === communityId
                        return ((data.conversationType)??"") === "roleSpecific" && data.communityId === communityId &&  userObjectGet.roles.some((element)=>{ return data.recipientRoles.replaceAll(/\s|_/g,"").toUpperCase().includes(element.replaceAll(/\s|_/g,"").toUpperCase())})
                    case "direct":
                        // return data.isIncident !== true && !data.recipientRoles
                        return ((data.conversationType)??"") === "direct";
                    default:
                        return false;
                }
                    
            }
        )
    },
    subscribeToRoleSpecificGroupConversationListData( newDataCallback, errorCallback, conversationFilterOption){
        if(conversationFilterOption === "role-specific"){
            return chatStrat.subscribeToCommunityRoleSpecificGroupEventHandlerWithPredicate(
                newDataCallback,
                errorCallback,
                ( data, index, arr )=>{
                    // console.log("Role Specific Group Data : ", data, userObjectGet, communityId )
                    let tempsome = userObjectGet.roles.some((element)=>{ return data.recipientRoles.replaceAll(/\s|_/g,"").toUpperCase().includes(element.replaceAll(/\s|_/g,"").toUpperCase())})
                    // data.recipientRoles.replaceAll(/\s|_/g,"").toUpperCase().includes(userObjectGet.roles[0].replaceAll(/\s|_/g,"").toUpperCase())
                    return data.communityId === communityId && tempsome && ((data.conversationType)??"") === "roleSpecific"
                }
            )
        }
        return ()=>{}
    },
    subscribeToMessageChannelData( msgId, newDataCallback, errorCallback){
        return chatStrat.subscribeToMessageEventHandler(
            msgId,
            newDataCallback,
            errorCallback
        )
    },
    sendMessage( msgChannelId, msgText, mediaUrl, groupOrRecipient = "Recipients", type = "none"){
        let aftMsgSentObj = null;
        switch (type){
            case "none":
                aftMsgSentObj = chatStrat.sendMessage( "" , msgChannelId, msgText, groupOrRecipient );
                break;
            case "image":
                aftMsgSentObj = chatStrat.sendImage(msgChannelId,mediaUrl, groupOrRecipient);
                break;
            default:
                console.log("Incorrent or Unimplemented Message type")
        }

        return aftMsgSentObj.then(
            ()=>{
                chatStrat.autoUpdateLastMessage(msgChannelId, groupOrRecipient);
            },
            (err)=>{
                // console.log("Error Occured In Sending Messages.",err)
            }
        )

    },
    accepteChatInvitation( msgChannelId ){
        chatStrat.acceptOrDeclineConversationInvite( msgChannelId , true )
        .then(
            (val)=>{
                chatStrat.updateParticipantsBasedOnInviteStates(msgChannelId)
            },
            (error)=>{
                // console.log("Error With Accepting Chat Invitation : ", error)
            }
        )
    },
    declineChatInvitation( msgChannelId ){
        chatStrat.acceptOrDeclineConversationInvite( msgChannelId, false)
        .then(
            (val)=>{
                chatStrat.updateParticipantsBasedOnInviteStates(msgChannelId)
            },
            (error)=>{
                // console.log("Error With Declining Chat Invitation : ", error)
            }
        )
    },
    async archiverChat( docId){

        return chatStrat.updateArchieveConversationStateByDocID( docId, true)
    },
    unArchiverChat( docId){

        chatStrat.updateArchieveConversationStateByDocID( docId, false)
    },
    async deleteChat( msgId){
        return chatStrat.userSpecificDeleteChat(msgId).then(
            ()=>{
                // console.log("Delete Chat Successful")
            },
            (err) => {
                // console.log("Delete Chant failed " , err)
            }
        )
    },
    async createGroupChat( GroupName = "" , groupParticipants = [] ){

        // console.log(`Create Group chat Service Called : \n Group Name ${GroupName} \n Group Participants ${groupParticipants}` )
        chatStrat.createNewGroupConversation(
            chatStrat?.userObject,
            groupParticipants,
            GroupName,
            "Hi"
        )
    },
    async createDirectChat ( participantObject , messageText ){
        return chatStrat.createNewDirectConversation(
            null,
            participantObject,
            messageText
        ).then(
            (convObject)=>{
                return chatStrat.sendMessage("", convObject.messageId, messageText, "Recipients").then(
                    ()=>{
                        // console.log("Within Success Promise Callback, AUTOUPDATE")
                        chatStrat.autoUpdateLastMessage(convObject.messageId, "Recipients");
                        return convObject
                    },
                    (val)=>{
                        // console.log("Error Occured In Sending Messages.",val)
                    }
                )
            },
            (error)=>{
                // console.log("Create new chat error : ", error)
            }
        )
    },
    async isConversationExistWithUser( recipientId){
        return chatStrat.isConversationExistWithUser(
            recipientId
        )
    },
    openChatView( conversationObject ){
        this._openChatViewSubject.next(conversationObject);
    },
    async createIncidentChat ( GroupName, groupParticipants, incidentId ){
        let result = groupParticipants.filter((val,ind,arr)=>{
            return val.userId !== chatStrat?.userObject.userId
        })
        return chatStrat.createNewGroupConversation( chatStrat?.userObject , result, GroupName,true, "",incidentId, {isIncident: true, communityId: communityId, recipientRoles: ""} )
        // console.log( " Way In : ",  chatStrat?.userObject , result, GroupName,true, "",incidentId, {isIncident: true, communityId: communityId, recipientRoles: ""}  )
    },
    addParticipantToGroupChat( participantArr, messageID ){
        return chatStrat.addParticipantToGroup(
            messageID, 
            participantArr,
            true
        )
    },
    removeParticipantById( participantId, messageID){
        try{
            return chatStrat.removeParticipantFromGroup(messageID,participantId)
        }catch(error){
            return Promise.reject({message:"an error", error:error})
        }
    },
    updateUserData( userId, userData){
        userObject = userData;
        chatStrat.updateAllUserObjects(userId, userData).then(
            (val)=>{ console.log(" User Data Updated ")},
            (error)=>{ console.log("Error Updating User Data : ", error)} 
        );
    },
    markMessageAsRead : async (messageId) => {
        return await chatStrat.markLatestMessageAsRead(messageId)
    },
    uploadChatImage: async (feedFileObject) =>{
        //feedFileObject should be the object you get from input event files => event.target.files[0]
        if( feedFileObject){
            const fileform = new FormData();
            fileform.append("file", feedFileObject);
            return axiosAuthInstance.post(
                "social/chat/media",
                fileform, {
                    headers:{
                        "Content-Type":"multipart/form-data",
                    }
                }
            ).then((res)=>{
                return res.data
            })
        }else{
            return Promise.resolve(null)
        }

    },
    setVirtualContactList: function ( tab, virtuallist ) {
        if(virtuallist){
            this._virutalContactList.set(tab, virtuallist);
        }
        
    },
    getVirtualContactList: function (){
        // console.log("GETTING VIRTUAL LIST : ", this._virutalContactList)
        return Array.from(this._virutalContactList.values(), (v,k)=>v).flatMap((item)=>item);
    }
}

export var FeedService = {
    subscribeToFeedsWithPredicate: (next, error, predicate) =>{

        return chatStrat.subscribeToFeedsByCommunityIdWithPredicate(
            next,
            error,
            predicate
        )
    },

    commentOnFeed : (feedId, commentText) => {
            return chatStrat.commentOnFeed(feedId, commentText)
        },

    createFeedPost : (message, media, hiveId, circleId) => {
        return chatStrat.createTextFeed(message, media, hiveId, circleId)
    },
    

    toggleLikeOnFeed : (feedId) => {
        // console.log("like toggle")
        return chatStrat.toggleLikeFeed(feedId)
    },

    getPostLink : (postObject) =>{
        return generateLinkForPost(postObject.id).then((data)=>{
            // console.log("the gotten link : ", data)
            chatStrat.updateShareLinkOfFeed( postObject.id, data.link)
            return data
        })
    },

    uploadFeedImage: async (feedFileObject) =>{
        //feedFileObject should be the object you get from input event files => event.target.files[0]
        if( feedFileObject){
            const fileform = new FormData();
            fileform.append("file", feedFileObject);
            return axiosAuthInstance.post(
                "social/posts/media",
                fileform, {
                    headers:{
                        "Content-Type":"multipart/form-data",
                    }
                }
            ).then((res)=>{
                return res.data
            })
        }else{
            return Promise.resolve(null)
        }

    },

    getFeedById :(feedId) => { 
        return chatStrat.getFeedById(feedId)
    },

    hasReadAllFeedsInHive : (hiveId, unreadCountDecrementValue)=>{
        // return axiosAuthInstance.put(
        //     `/social/hives/${hiveId}/counter`,
        //     null,
        //     {
        //         params:{readCount : unreadCountDecrementValue}
        //     }
        // ).then((res)=>{
        //     return res.data
        // })
        return axiosAuthInstance.post(
            `/social/hives/${hiveId}/mark-as-read`,
        )
    }


}

async function generateLinkForPost(postId){
    return await axiosAuthInstance.get(`/social/posts/${postId}/link`)
    .then((result)=>{
        return result.data
    } )
}

// ChatService.initialize();
// console.log("blume")

export default ChatService;